import { ibkApi } from '@ibk/shared-config';
const contractConfigsTag = (contractId) => ({ type: 'Emissor', id: `contract-configs-${contractId}` });
export const buildGetContractConfigsQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/configs`,
    method: 'GET',
});
export const transformGetContractConfigsResponse = (response) => response.result ?? [];
export const buildUpdateContractConfigsMutation = ({ contractId, configs }) => ({
    url: `/v1/benefits/contracts/${contractId}/configs`,
    method: 'PUT',
    body: { configs },
});
export const transformUpdateContractConfigsResponse = (response) => response.result ?? [];
export const contractConfigsApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getEmissorContractConfigs: build.query({
            query: buildGetContractConfigsQuery,
            transformResponse: transformGetContractConfigsResponse,
            providesTags: (_result, _error, { contractId }) => [contractConfigsTag(contractId)],
        }),
        updateEmissorContractConfigs: build.mutation({
            query: buildUpdateContractConfigsMutation,
            transformResponse: transformUpdateContractConfigsResponse,
            invalidatesTags: (_result, error, { contractId }) => (error ? [] : [contractConfigsTag(contractId)]),
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorContractConfigsQuery, useUpdateEmissorContractConfigsMutation } = contractConfigsApi;
